/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { numericRangeResponseDtoSchema } from "./numericRangeResponseDtoSchema";
import { z } from "zod/v4";

export const propertyNeedsResponseDtoSchema = z.object({
    get "bedrooms"(){
                return numericRangeResponseDtoSchema.optional()
              },
get "bathrooms"(){
                return numericRangeResponseDtoSchema.optional()
              },
get "squareFootage"(){
                return numericRangeResponseDtoSchema.optional()
              },
"propertyType": z.optional(z.string()),
"location": z.optional(z.string()),
"preferences": z.optional(z.array(z.string()))
    })